function Footer() {
    return (
        <footer>
            <div>
                <p>Website design and development by Jihan
                </p>
            </div>
            <div>
                <a href="mailto:jihan.duerme@gmail.com">jihan.duerme@gmail.com</a>
                <div>
                    <a href="https://www.linkedin.com/in/jihanduerme/" target="_blank" rel="noopener noreferrer">
                        <i className="bi bi-linkedin"></i>
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;